import React from 'react';
export function Footer() {
  return <footer className="bg-[#0D3A29] px-4 py-12 text-center text-sm text-white/60" data-id="element-70" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-4xl" data-id="element-71" data-mp="3gg0yw2enzvx4">
        <div className="mb-3 font-serif text-xl font-bold text-white" data-id="element-72" data-mp="3gh3n22klrk9c">BIOLOGÍA LISTA</div>
        <p className="mx-auto max-w-md text-xs leading-relaxed text-white/50" data-id="element-73" data-mp="32lrnnhvi55m3">
          La colección completa de Ciencias para docentes: Primaria y Secundaria, lista para imprimir y enseñar.
        </p>
        <nav aria-label="Legal" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-6" data-id="element-74" data-mp="3ud7i1y3avwmv">
          <a href="#terminos" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-75" data-mp="3lecaahklyehg">
            Términos y Condiciones
          </a>
          <a href="#privacidad" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-76" data-mp="3qc41189inuk2">
            Política de Privacidad
          </a>
          <a href="#contacto" className="transition-colors duration-200 ease-out hover:text-white" data-id="element-77" data-mp="2ey9zdwbg4pnv">
            Contacto
          </a>
        </nav>
        <p data-id="element-78" data-mp="3labq1ri0byo9">© 2026 Biología Lista. Todos los derechos reservados.</p>
      </div>
    </footer>;
}